import { render, staticRenderFns } from "./CAxAAMxAffectivityPage.vue?vue&type=template&id=34166a7e"
import script from "./CAxAAMxAffectivityPage.vue?vue&type=script&lang=js"
export * from "./CAxAAMxAffectivityPage.vue?vue&type=script&lang=js"
import style0 from "./CAxAAMxAffectivityPage.vue?vue&type=style&index=0&id=34166a7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports